import { useMemo } from 'react'

const useTenant = () => {
  // Use hostname (no port) so local dev "localhost:3000" doesn't get sent to APIs.
  // Example: window.location.hostname === "localhost"
  const tenantSlug = useMemo(() => window.location.hostname.split('.')[0], [])

  return {
    tenantSlug,
  }
}

export default useTenant
